import { HTTP_CODE } from '@/utils/request'
import * as service from './service'

export default {
  namespace: 'shansongValueHome',
  state: {
    demoData: {}
  },
  effects: {
    * getCourierScoreHome ({ payload }, { call, put }) {
      const res = yield call(service.getCourierScoreHome, payload)
      if (res.data.status !== HTTP_CODE.success) {
        throw new Error(res.data.err)
      }
      return res.data.data
    },

    * firstWatch ({ payload }, { call, put }) {
      const res = yield call(service.firstWatch, payload)
      if (res.data.status !== HTTP_CODE.success) {
        throw new Error(res.data.err)
      }
      return res.data.data
    }

  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }

  // effects: {
  //   * levelRecord ({ payload }, { call, put }) {
  //     const res = yield call(service.levelRecord, payload)
  //     yield put({
  //       type: 'save',
  //       payload: {
  //         levelRecord: res.data.data
  //       }
  //     })
  //   }
  // },
  // reducers: {
  //   save (state, { payload }) {
  //     return { ...state, ...payload }
  //   }
  // }

}
